var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quiz-Node",
    transform: "translate(-122.000000, -923.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "project",
    transform: "translate(122.000000, 923.000000)",
    fill: "#C0C0C0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,4.88888889 C10.16352,4.88888889 9.553032,4.63135444 9.102948,4.17292333 L7.757364,2.80242111 C7.532316,2.57321778 7.227096,2.44444444 6.908832,2.44444444 L3.6,2.44444444 C2.937264,2.44444444 2.4,2.99165778 2.4,3.66666667 L2.4,18.3333333 C2.4,19.0083667 2.937264,19.5555556 3.6,19.5555556 L20.4,19.5555556 C21.06276,19.5555556 21.6,19.0083667 21.6,18.3333333 L21.6,6.11111111 C21.6,5.43610222 21.06276,4.88888889 20.4,4.88888889 L10.8,4.88888889 Z M10.8,2.44444444 L20.4,2.44444444 C22.38828,2.44444444 24,4.08607222 24,6.11111111 L24,18.3333333 C24,20.3584333 22.38828,22 20.4,22 L3.6,22 C1.61178,22 0,20.3584333 0,18.3333333 L0,3.66666667 C0,1.64162778 1.61178,0 3.6,0 L6.908832,0 C7.863612,0 8.779284,0.386307778 9.454416,1.07394222 L10.8,2.44444444 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.719df44cd7db943c6c16a68716728646.svg";
export { ForwardRef as ReactComponent };